import { PureComponent } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Container, Grid } from 'semantic-ui-react';

import { SuccessContainer } from '../../components';

import './auth.scss';

class VerificationLink extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { t } = this.props;
    return (
      <Grid.Row>
        {/* <Grid.Column mobile={16} tablet={5} computer={5} />
        <Grid.Column mobile={16} tablet={6} computer={6}> */}
        <Container className="email-verification-container">
          <Grid>
            <Grid.Row>
              <SuccessContainer
                header={t('auth.verification.almost_there')}
                msg={t(
                  'auth.verification.we_have_sent_you_a_verification_link'
                )}
                description={[
                  <span>{t('auth.verification.description.line1')}</span>,
                  <br />,
                  <span>{t('auth.verification.description.line2')}</span>,
                ]}
                success={true}
                button={t('auth.verification.button')}
                buttonRoute="/signin"
              />
            </Grid.Row>
          </Grid>
        </Container>
        {/* </Grid.Column>
        <Grid.Column mobile={16} tablet={5} computer={5} /> */}
      </Grid.Row>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch);
};

VerificationLink = connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(VerificationLink));
export default VerificationLink;
